<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="for-leanna">
<h1>For Leanna</h1>
<p style=" text-indent:1em;">My therapist</p>
<p>You are the light</p>
<p>Of grace</p>
<p>In the human form</p>
<p>Of compassion</p>
<p>Our time is sacred</p><br/>
<p>You saved me</p><br/>
<p>When my nerves</p>
<p>Were on</p>
<p>The third rail</p>
<p>I was laying down</p>
<p>On the tracks</p>
<p>When I found you</p><br/>
<p>You found in me</p>
<p>The different ways</p>
<p>To make the trains</p>
<p>Stop from coming</p>
<p>Before it was too late</p><br/>
<p>I am eternally grateful</p>
<p>For you Leanna</p>
<p>For being there</p>
<p>When I needed you</p><br/>
<p>The most.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?18f7d4ce